import { ReactNode } from "react";
import { Overlay, TooltipBox } from "./TooltipModalStyles";
import ButtonGradient from "../ui/ButtonGradient";

interface TooltipModalProps {
  children: ReactNode;
  onClose: () => void;
  buttonLabel?: string;
}

const TooltipModal = ({
  children,
  onClose,
  buttonLabel,
}: TooltipModalProps) => {
  return (
    <Overlay>
      <TooltipBox>
        {children}
        <ButtonGradient onClick={onClose}>{buttonLabel}</ButtonGradient>
      </TooltipBox>
    </Overlay>
  );
};

export default TooltipModal;
